import { MessageCircle } from 'lucide-react';
import { useTranslation } from 'react-i18next';

const WhatsAppButton = () => {
  const { i18n } = useTranslation();
  
  // WhatsApp Business link provided by client
  const whatsappUrl = 'https://wa.me/31625381824';
  
  const tooltip = i18n.language === 'nl' ? 'Chat met ons' : 'Chat with us';

  return (
    <a
      href={whatsappUrl}
      target="_blank"
      rel="noopener noreferrer"
      className="fixed bottom-6 right-6 z-40 w-14 h-14 bg-green-500 hover:bg-green-600 rounded-full flex items-center justify-center shadow-lg hover:shadow-xl transition-all duration-300 hover:scale-110 group"
      aria-label="Contact us on WhatsApp"
      data-testid="whatsapp-floating-button"
    >
      <MessageCircle className="w-6 h-6 text-white" aria-hidden="true" />
      <span className="absolute right-full mr-3 px-3 py-2 bg-navy-800 text-white text-sm rounded-lg opacity-0 group-hover:opacity-100 transition-opacity whitespace-nowrap" role="tooltip">
        {tooltip}
      </span>
    </a>
  );
};

export default WhatsAppButton;
